import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaMedal, FaUserCircle } from "react-icons/fa";
import { MdFilterList, MdRefresh } from "react-icons/md";
import { TbCoins } from "react-icons/tb";
import "./LeaderBoard.css";
import first from "../../assets/TeamsLeaderboard1.png";
import second from "../../assets/TeamsLeaderboard2.png";
import third from "../../assets/TeamsLeaderboard3.png";
import blasterRight from "../../assets/blasterRight.png";
import blasterLeft from "../../assets/blasterLeft.png";
import { FaFilter } from "react-icons/fa";
import { IoRefreshSharp } from "react-icons/io5";
import { GiTwoCoins } from "react-icons/gi";
import moment from "moment-timezone";
import Loader from "components/Loaders/Loader";
import DatePicker from "react-datepicker";
import { useNavigate } from "react-router-dom";
import { fetchGroups } from "components/API/ApiEnpoints";
import { useCheckSessionHeartBeat } from "components/API/ApiEnpoints";
import { SessionExtend } from "components/utils/SessionCheckUtils";
// @ts-ignore
import confetti from "canvas-confetti";
import StreakLeaderboard from "components/Teams/Leaderboard/StreakLeaderboard";

import {
  FaEnvelope,
  FaPhoneAlt,
  FaBuilding,
  FaGlobe,
  FaCity,
  FaUsers,
} from "react-icons/fa";
import {
  MdOutlineDeviceUnknown,
  MdOutlineNotificationsActive,
} from "react-icons/md";

interface LeaderboardEntry {
  rank: number;
  name: string;
  points: number;
  iconColor?: string;
  image: any;
  unit: string;
  user_uid: string;
  showIcon: boolean;
}

type CustomInputProps = {
  value?: string;
  onClick?: () => void;
};

const groupUids = JSON.parse(localStorage.getItem("group_uids") || "[]");
//const storedGroupNames = JSON.parse(localStorage.getItem("group_names") || "[]");
const Leaderboard: React.FC = () => {
  useCheckSessionHeartBeat();
  const beAddress =
    window._env_?.REACT_APP_API_URL || process.env.REACT_APP_API_URL;

  const sessionUid = localStorage.getItem("session_uid") || "";
  const userUid = localStorage.getItem("user_uid") || "";

  const navigate = useNavigate();

  const [leaderboard, setLeaderboard] = useState<LeaderboardEntry[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [selectedDuration, setSelectedDuration] = useState("weekly");
  const [selectedGroup, setSelectedGroup] = useState<string>("");
  const [selectedFilter, setSelectedFilter] = useState<string>("steps");
  const [appliedFilter, setAppliedFilter] = useState<string>("steps");
  const [tempFilter, setTempFilter] = useState<string>("steps");
  const [storedGroupNames, setStoredGroupNames] = useState<string[]>([]);
  const [selectedGroupUid, setSelectedGroupUid] = useState<string>("");
  const [filterApplied, setFilterApplied] = useState<boolean>(false);
  const [loadingGroups, setLoadingGroups] = useState<boolean>(true);
  const [fromDatetime, setFromDatetime] = useState<string>("");
  const [toDatetime, setToDatetime] = useState<string>("");
  const [fromDate, setFromDate] = useState<Date | null>(new Date());
  const [toDate, setToDate] = useState<Date | null>(new Date());
  const [isPopupOpen, setIsPopupOpen] = useState<boolean>(false);
  const [groupUids, setGroupUids] = useState<string[]>([]);
  const [userProfile, setUserProfile] = useState<any>(null);
  const [isProfilePopupOpen, setIsProfilePopupOpen] = useState<boolean>(false);
  const [userImages, setUserImages] = useState<{ [key: string]: string }>({});
  const [useCustomDateRange, setUseCustomDateRange] = useState(false);
  const [isFilterMode, setIsFilterMode] = useState(false);
  const defaultSelectedDuration = "daily";
  const userPrivilege = localStorage.getItem("privilege");
  const defaultSelectedGroup = "";
  const defaultFromDatetime = moment
    .utc()
    .startOf("day")
    .format("YYYY-MM-DDTHH:mm:ss[Z]");
  const defaultToDatetime = moment
    .utc()
    .endOf("day")
    .format("YYYY-MM-DDTHH:mm:ss[Z]");
  const [isOrgLeaderboard, setIsOrgLeaderboard] = useState(false);
  const [isOrgFilterLeaderboard, setIsOrgFilterLeaderboard] = useState(false);
  const [tempGroup, setTempGroup] = useState<string>("");
  const [tempFromDate, setTempFromDate] = useState<Date | null>(new Date());
  const [tempToDate, setTempToDate] = useState<Date | null>(new Date());
  const [progress, setProgress] = useState(0);
  const [tempSelectedDuration, setTempSelectedDuration] = useState("weekly");
  const [tempSelectedFilter, setTempSelectedFilter] = useState("steps");
  const [tempSelectedGroup, setTempSelectedGroup] = useState("all");
  const [suppressNextFetch, setSuppressNextFetch] = useState(false);
  const [showStreak, setShowStreak] = useState(false);


  const loggedInUser = leaderboard.find((entry) => entry.user_uid === userUid);
  const isSmallList = leaderboard.length <= 5;

  // Create padded top five
  let paddedTopFive: LeaderboardEntry[] = [...leaderboard];

  if (isSmallList) {
    for (let i = paddedTopFive.length; i < 5; i++) {
      paddedTopFive.push({
        rank: i + 1,
        name: "Not yet claimed",
        points: 0,
        unit: "",
        image: null,
        user_uid: `placeholder-${i}`,
        showIcon: true,
      });
    }
  }

  // Always ensure topThree has 3 elements
  const topThree = paddedTopFive.slice(0, 3);
  const isInTop3 = topThree.some((entry) => entry.user_uid === userUid);

  // Build rest of the list (4th & 5th), excluding "You" if shown separately
  const rest = paddedTopFive
    .slice(3)
    .filter((entry) => entry.user_uid !== loggedInUser?.user_uid);

  // Remove user from rest if already in it (to avoid duplicate)
  const filteredRest = rest.filter((entry) => entry.user_uid !== userUid);
  const showUserCard =
    loggedInUser &&
    !topThree.find((entry) => entry.user_uid === loggedInUser.user_uid);

  useEffect(() => {
    const loadGroups = async () => {
      const data = await fetchGroups(sessionUid, userUid, {});
      console.log("Group response:", data);

      if (data && typeof data === "object") {
        const groupNames: string[] = [];
        const groupUids: string[] = [];

        Object.values(data).forEach((categoryGroups) => {
          if (Array.isArray(categoryGroups)) {
            categoryGroups.forEach((group) => {
              if (group.group_name && group.group_uid) {
                groupNames.push(group.group_name);
                groupUids.push(group.group_uid);
              }
            });
          } else {
            console.warn("Skipped non-array category:", categoryGroups);
          }
        });

        setStoredGroupNames(groupNames);
        setGroupUids(groupUids);
        setLoadingGroups(false);
      } else {
        console.error("Invalid group data:", data);
      }
    };

    loadGroups();
  }, []);

  useEffect(() => {
    if (!useCustomDateRange && selectedDuration) {
      let from: Date;
      let to: Date = moment().endOf("day").toDate();

      if (selectedDuration === "daily") {
        from = moment().startOf("day").toDate();
      } else if (selectedDuration === "weekly") {
        from = moment().startOf("isoWeek").toDate();
      } else {
        from = moment().startOf("month").toDate();
      }

      setFromDate(from);
      setToDate(to);

      setTempFromDate(from);
      setTempToDate(to);
    }
  }, [selectedDuration, useCustomDateRange]);


  // useEffect(() => {
  //   fetchLeaderboard();
  // }, []);
  useEffect(() => {
    if (fromDate) {
      const formatted = moment
        .utc(fromDate)
        .startOf("day")
        .format("YYYY-MM-DDTHH:mm:ss[Z]");
      setFromDatetime(formatted);
    }
  }, [fromDate]);

  useEffect(() => {
    if (toDate) {
      const formatted = moment
        .utc(toDate)
        .endOf("day")
        .format("YYYY-MM-DDTHH:mm:ss[Z]");
      setToDatetime(formatted);
    }
  }, [toDate]);

  useEffect(() => {
    if (!useCustomDateRange && selectedDuration) {
      if (suppressNextFetch) {
        setSuppressNextFetch(false);
        return;
      }
      fetchLeaderboard();
    }
  }, [selectedDuration, isOrgLeaderboard]);

  // useEffect(() => {
  //   fetchLeaderboard();
  // }, [selectedGroup, selectedFilter,isOrgLeaderboard]);

  const handleGroupChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const groupName = e.target.value;
    setSelectedGroup(groupName);

    const groupIndex = storedGroupNames.indexOf(groupName);
    if (groupIndex !== -1) {
      setSelectedGroupUid(groupUids[groupIndex]);
    } else {
      setSelectedGroupUid("");
    }
  };

  const fireSideConfetti = () => {
    // Left cannon
    confetti({
      particleCount: 60,
      angle: 60,
      spread: 55,
      origin: { x: 0, y: 0.4 },
      colors: ["#ffae00", "#ff0055", "#00c8ff", "#00ff88"],
    });

    // Right cannon
    confetti({
      particleCount: 60,
      angle: 120,
      spread: 55,
      origin: { x: 1, y: 0.4 },
      colors: ["#ffae00", "#ff0055", "#00c8ff", "#00ff88"],
    });

    // Floating soft rain
    var duration = 2 * 1000;
    var end = Date.now() + duration;

    (function frame() {
      confetti({
        particleCount: 3,
        startVelocity: 20,
        ticks: 300,
        origin: { x: Math.random(), y: -0.1 }
      });

      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    })();
  };
  useEffect(() => {
    if (!loading && leaderboard.length > 0) {
      fireSideConfetti();
    }
  }, [loading]);


  const handleMemberClick = async (user_uid: string) => {
    await fetchUserProfile(user_uid);
    setIsProfilePopupOpen(true);
  };

  const fetchUserProfile = async (user_uid: string) => {
    try {
      const userImage = userImages[user_uid] || null;

      const response = await axios.get(`${beAddress}/api/public-user-profile`, {
        headers: {
          "Content-Type": "application/json",
          "user-uid": userUid,
        },
        params: {
          target_user_uid: user_uid,
        },withCredentials: true,
      });

      if (
        response.data.status === "Success" &&
        typeof response.data.data === "object"
      ) {
        const userData = response.data.data;
        userData.image = userImage;
        setUserProfile(userData);
      } else {
        console.error("Invalid data format in API response");
      }
      SessionExtend();
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };

  const handleFilterChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;

    if (value === "overall-performance") {
      // Treat this like no filter selected
      //console.log("No specific filter selected (Overall Performance)");
      // You can skip filter logic or reset data
    } else {
      //console.log("Selected metric:", value);
      // Apply filtering logic
    }

    setSelectedFilter(value);
  };

  const resetFilters = () => {
    const today = moment.utc().toDate();
    const startOfWeek = moment.utc().startOf("isoWeek").toDate();

    setSuppressNextFetch(true);

    // Reset the main leaderboard filters
    setFromDate(startOfWeek);
    setToDate(today);

    // Reset modal temporary values that the modal actually reads
    setTempFromDate(startOfWeek);
    setTempToDate(today);
    setTempFilter("steps");
    setTempGroup("");
    // Reset global state for applied filters
    setIsFilterMode(false);
    setUseCustomDateRange(false);
    setSelectedDuration("weekly");
    setSelectedGroupUid("");
    setSelectedFilter("steps");
    setAppliedFilter("");
    setSelectedGroup("all");

    // Fetch default leaderboard with correct dates
    fetchLeaderboard({
      filterType: "steps",
      groupName: "all",
      from: startOfWeek,
      to: today,
    });
  };

  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  const handleApplyFilters = () => {
    setIsPopupOpen(false);
    setIsFilterMode(true);

    if (tempGroup === "__my_org__") {
      setIsOrgFilterLeaderboard(true);
    } else {
      setIsOrgFilterLeaderboard(false);
    }

    setSelectedFilter(tempFilter);
    setAppliedFilter(tempFilter);
    setSelectedGroup(tempGroup);
    setFromDate(tempFromDate);
    setToDate(tempToDate);
    setUseCustomDateRange(true);

    fetchLeaderboard({
      filterType: tempFilter,
      groupName: tempGroup,
      from: tempFromDate,
      to: tempToDate,
    });
  };

  const fetchImagesByUid = async (
    imageUids: string[]
  ): Promise<Record<string, string>> => {
    if (!imageUids || imageUids.length === 0) {
      return {};
    }

    try {
      // Build URL with multiple image_uid_list params
      const url = new URL(`${beAddress}/api/get-image-by-uid`);
      imageUids.forEach((uid) =>
        url.searchParams.append("image_uid_list", uid)
      );
      url.searchParams.set("is_icon_img", "true");
      url.searchParams.set("is_feedback_image", "false");

      const res = await fetch(url.toString(), {
        headers: {
          "user-uid": userUid,
        },credentials: "include",
      });

      const data = await res.json();

      if (data.status === "Success" && Array.isArray(data.data)) {
        return Object.fromEntries(
          data.data.map((item: any) => {
            if (item.default) return [item.image_uid, ""]; // default placeholder
            return [item.image_uid, item.image];
          })
        );
      }
      SessionExtend();
    } catch (err) {
      console.error("Failed to fetch images:", err);
    }

    return {};
  };

  const fetchLeaderboard = async ({
    filterType = appliedFilter,
    groupName = selectedGroup,
    from = fromDate,
    to = toDate,
  }: {
    filterType?: string;
    groupName?: string;
    from?: Date | null;
    to?: Date | null;
  } = {}) => {
    setLoading(true);
    setError(null);
    setProgress(0);

    let progressValue = 0;
    const interval = setInterval(() => {
      progressValue += Math.random() * 2.5;
      if (progressValue < 95) {
        setProgress(progressValue);
      } else {
        clearInterval(interval);
      }
    }, 300);

    try {
      let fromDatetime = "";
      let toDatetime = "";
      const useCustomRangeActive = useCustomDateRange && from && to;

      if (useCustomRangeActive) {
        fromDatetime = moment
          .utc(moment(from).format("YYYY-MM-DD"))
          .startOf("day")
          .format("YYYY-MM-DDTHH:mm:ss[Z]");
        toDatetime = moment
          .utc(moment(to).format("YYYY-MM-DD"))
          .endOf("day")
          .format("YYYY-MM-DDTHH:mm:ss[Z]");

      } else {
        if (selectedDuration === "daily") {
          fromDatetime = moment
            .utc()
            .startOf("day")
            .format("YYYY-MM-DDTHH:mm:ss[Z]");
          toDatetime = moment
            .utc()
            .endOf("day")
            .format("YYYY-MM-DDTHH:mm:ss[Z]");
        } else if (selectedDuration === "weekly") {
          fromDatetime = moment
            .utc()
            .startOf("isoWeek")
            .format("YYYY-MM-DDTHH:mm:ss[Z]");
          toDatetime = moment
            .utc()
            .endOf("day")
            .format("YYYY-MM-DDTHH:mm:ss[Z]");
        } else if (selectedDuration === "monthly") {
          fromDatetime = moment
            .utc()
            .startOf("month")
            .format("YYYY-MM-DDTHH:mm:ss[Z]");
          toDatetime = moment
            .utc()
            .endOf("day")
            .format("YYYY-MM-DDTHH:mm:ss[Z]");
        }
      }

      const params: any = {
        from_datetime: fromDatetime,
        to_datetime: toDatetime,
      };

      if (groupName === "__my_org__") {
        params.is_org_leaderboard = true;
      } else {
        const groupIndex = storedGroupNames.indexOf(groupName || "");
        if (groupIndex !== -1 && groupUids[groupIndex]) {
          params.group_uid = groupUids[groupIndex];
        }
      }

      if (filterType && filterType !== "overall-performance") {
        params.filter_type = filterType;
      }

      const response = await axios.get(
        `${beAddress}/api/get-team-leaderboard`,
        {
          headers: {
            "user-uid": userUid,
          },withCredentials: true,
          params,
        }
      );

      if (response.data) {
        const leaderboardData = response.data.data;

        // Collect unique image_uids
        const imageUids = leaderboardData
          .filter((m: any) => m.image_uid && m.image_uid !== "")
          .map((m: any) => m.image_uid);

        // Fetch actual images
        const imageResponse = await fetchImagesByUid(imageUids);

        // Map leaderboard
        const mappedLeaderboard = leaderboardData.map(
          (member: any, index: number) => {
            let imageSrc = "";
            let showIcon = false;

            if (!member.image_uid || member.image_uid === "") {
              showIcon = true; // default image case
            } else if (imageResponse[member.image_uid]) {
              const base64Img = imageResponse[member.image_uid];
              let mimeType = "image/png";

              if (base64Img.startsWith("R0lGODlh")) mimeType = "image/gif";
              else if (base64Img.startsWith("/9j/")) mimeType = "image/jpeg";
              else if (base64Img.startsWith("iVBORw0KGgo"))
                mimeType = "image/png";

              imageSrc = `data:${mimeType};base64,${base64Img}`;
            } else {
              showIcon = true;
            }

            userImages[member.user_uid] = imageSrc;

            return {
              rank: index + 1,
              name: member.user_name,
              points: member.value,
              unit: member.unit === "count" ? "Steps" : member.unit,
              image: imageSrc,
              showIcon: showIcon,
              user_uid: member.user_uid,
            };
          }
        );

        setLeaderboard(mappedLeaderboard);
        setUserImages({ ...userImages });
      }
      SessionExtend();
    } catch (err) {
      setError("Failed to fetch leaderboard.");
      console.error(err);
    } finally {
      clearInterval(interval);
      setProgress(100);

      setTimeout(() => {
        setLoading(false);
        setProgress(0);
      }, 500);
    }
  };

  const handleFilterClick = () => {
    setIsPopupOpen(true);
    const today = new Date();
    setTempFromDate(today);
    setTempToDate(today);
    setIsFilterMode(true);
  };

  const CustomInput = React.forwardRef<HTMLInputElement, CustomInputProps>(
    ({ value, onClick }, ref) => (
      <input
        className="leaderboard-datepicker"
        onClick={onClick}
        value={value}
        readOnly
        ref={ref}
      />
    )
  );

  const getStatusInfo = (status: string) => {
    switch (status) {
      case "active":
        return { color: "#16821aff", label: "Online", iconname: "checkcircle" }; // green 16821aff
      case "away":
        return { color: "#f6c70aff", label: "Away", iconname: "clockcircle" }; // yellow f6c70aff
      case "invited":
        return {
          color: "#000000",
          label: "Inactive",
          iconname: "exclamationcircle",
        }; // black
      default:
        return {
          color: "#9b9292ff",
          label: "Offline",
          iconname: "closecircle",
        }; // black
    }
  };

return (
  <>
    {loading && (
      <div className="progress-bar-container">
        <div
          className="progress-bar-fill"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
    )}

    {userPrivilege === "systemadmin" ? (
      <div className="access-denied-message">Access Denied</div>
    ) : (
      <div className="leaderboard-container">

        <div className="leaderboard-toggle">
          {!showStreak ? (
            <button
              className="toggle-btn"
              onClick={() => setShowStreak(true)}
            >
              Streak Leaderboard
            </button>
          ) : (
            <button
              className="toggle-btn"
              onClick={() => setShowStreak(false)}
            >
              Leaderboard
            </button>
          )}
        </div>

       
      

            <img src={blasterLeft} alt="Blaster Left" className="blaster left" />
            <img src={blasterRight} alt="Blaster Right" className="blaster right" />
  {!showStreak ? (
          <>
            <div className="leaderboard-title">LEADERBOARD</div>

            {/* Duration Tabs + Filter */}
            {!isFilterMode && (
              <div className="duration-tabs-wrapper">
                <div className="filter-item" onClick={() => setIsPopupOpen(true)}>
                  <FaFilter className="filter-icon" />
                  <span>Filter By</span>
                </div>

                <div className="duration-tabs">
                  {["daily", "weekly", "monthly"].map((d) => (
                    <button
                      key={d}
                      className={`tab-button ${selectedDuration === d ? "active" : ""}`}
                      onClick={() => {
                        setSelectedDuration(d);
                        setIsOrgLeaderboard(false);
                        setUseCustomDateRange(false);
                      }}
                    >
                      {d.charAt(0).toUpperCase() + d.slice(1)}
                    </button>
                  ))}
                </div>
              </div>
            )}

          {loading ? (
            <Loader />
          ) : (
            <>
              {/* <div className="filter-bar"> */}
              {/* <div className="filter-item" onClick={togglePopup}>
              <FaFilter className="filter-icon" />
              <span>Filter By</span>
            </div> */}
              {/* <div className="reset-filter" onClick={resetFilters}>
                <MdRefresh className="reset-icon" />
                <span>Reset Filter</span>
              </div> */}
              {isFilterMode && useCustomDateRange && (
                <div className="filter-bar">
                  <div className="filter-item" onClick={togglePopup}>
                    <FaFilter className="filter-icon" />
                    <span>Filter By</span>
                  </div>

                  {/* ✅ SHOW APPLIED FILTERS */}
                  <div className="applied-filters">
                    <span><strong>Applied Filters:</strong></span>
                    <span> | From: {fromDate?.toLocaleDateString()}</span>
                    <span> | To: {toDate?.toLocaleDateString()}</span>
                    <span> | Metric: {selectedFilter}</span>
                    <span>
                      | Group: {selectedGroup === "__my_org__" ? "My Org" : selectedGroup || "All"}
                    </span>
                  </div>

                  {/* ✅ RESET FILTER NOW VISIBLE */}
                  <div className="reset-filter" onClick={resetFilters}>
                    <MdRefresh className="reset-icon" />
                    <span>Reset Filter</span>
                  </div>
                </div>
              )}



                {/* Filter Popup */}
                {isPopupOpen && (
                  <div className="leaderboard-popup">
                    <div className="leaderboard-popup-content">
                      <span className="leaderboard-close" onClick={togglePopup}>
                        &times;
                      </span>

                      <h2 className="leaderboard-popup-title">Select Filters</h2>

                      {/* Group */}
                      <div className="leaderboard-filter-group">
                        <label>Select Group:</label>
                        <select
                          className="leaderboard-select"
                          value={tempGroup}
                          onChange={(e) => {
                            const groupName = e.target.value;
                            setTempGroup(groupName);

                            if (groupName === "__my_org__") {
                              setIsOrgFilterLeaderboard(true);
                            } else {
                              setIsOrgFilterLeaderboard(false);
                              const groupIndex = storedGroupNames.indexOf(groupName);
                              setSelectedGroupUid(
                                groupIndex !== -1 ? groupUids[groupIndex] : ""
                              );
                            }
                          }}
                        >
                          <option value="">All</option>
                          <option value="__my_org__">My Org</option>
                          {storedGroupNames.map((groupName, index) => (
                            <option key={index} value={groupName}>
                              {groupName}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* Metric */}
                      <div className="leaderboard-filter-group">
                        <label>Select Metric:</label>
                        <select
                          className="leaderboard-select"
                          value={tempFilter}
                          onChange={(e) => setTempFilter(e.target.value)}
                        >
                          <option value="" disabled hidden>Select a metric</option>
                          <option value="overall-performance">Overall Performance</option>
                          <option value="steps">Steps</option>
                          <option value="distance">Distance</option>
                          <option value="caloriesburned">Calories Burned</option>
                        </select>
                      </div>

                      {/* From Date */}
                      <div className="leaderboard-filter-group">
                        <label>From Date:</label>
                        <DatePicker
                          selected={tempFromDate}
                          onChange={(date) => {
                            setTempFromDate(date);
                            setUseCustomDateRange(true);
                            setSelectedDuration("");
                          }}
                          maxDate={new Date()}
                          dateFormat="yyyy-MM-dd"
                          customInput={<CustomInput />}
                        />
                      </div>

                      {/* To Date */}
                      <div className="leaderboard-filter-group">
                        <label>To Date:</label>
                        <DatePicker
                          selected={tempToDate}
                          onChange={(date) => {
                            setTempToDate(date);
                            setUseCustomDateRange(true);
                            setSelectedDuration("");
                          }}
                          minDate={tempFromDate || undefined}
                          maxDate={new Date()}
                          dateFormat="yyyy-MM-dd"
                          customInput={<CustomInput />}
                        />
                      </div>

                      <button className="leaderboard-apply-button" onClick={handleApplyFilters}>
                        Apply
                      </button>
                    </div>
                  </div>
                )}

              <div className="leaderboard-members-list">
                {topThree.map((member, index) => (
                  <div
                    key={member.user_uid}
                    className={`leaderboard-member-card ${index === 0
                      ? "first-place"
                      : index === 1
                        ? "second-place"
                        : "third-place"
                      }`}
                    onClick={() =>
                      member.user_uid.startsWith("placeholder")
                        ? null
                        : handleMemberClick(member.user_uid)
                    }
                  >
                    {member.showIcon ? (
                      <FaUserCircle
                        style={{ fontSize: "100px", color: "gray" }}
                      />
                    ) : (
                      <img
                        src={member.image}
                        alt={member.name}
                        className="leaderboard-image"
                      />
                    )}
                    <div className="leaderboard-progress-circle">
                      {member.rank}
                    </div>
                    <div className="leaderboard-member-info">
                      <p className="leaderboard-name">
                        {member.user_uid.startsWith("placeholder")
                          ? "Not yet claimed"
                          : member.name}
                      </p>
                      <span className="leaderboard-points">
                        {member.user_uid.startsWith("placeholder")
                          ? "--"
                          : `${member.points} ${member.unit}`}
                      </span>
                    </div>
                  </div>
                ))}
              </div>

                {/* Main List */}
                <div className="leaderboard-list">
                  {loggedInUser && !isInTop3 && (
                    <div
                      key="you-highlight"
                      className="leaderboard-list-item you-highlight"
                      onClick={() => handleMemberClick(loggedInUser.user_uid)}
                    >
                      <div className="leaderboard-list-item1">
                        <div className="leaderboard-rank-list1">{loggedInUser.rank}</div>

                        <div className="leadership-name-image-container">
                          {loggedInUser.showIcon ? (
                            <FaUserCircle style={{ fontSize: "40px", color: "black" }} />
                          ) : (
                            <img
                              src={loggedInUser.image}
                              alt={loggedInUser.name}
                              className="leaderboard-list-image"
                            />
                          )}

                          <p className="leaderboard-list-name">
                            {loggedInUser.name} <span style={{ fontWeight: 500 }}>(You)</span>
                          </p>
                        </div>
                      </div>

                      <div className="leaderboard-list-points">
                        {loggedInUser.points} {loggedInUser.unit}
                      </div>
                    </div>
                  )}

                  {rest.map((member) => (
                    <div
                      key={member.user_uid}
                      className="leaderboard-list-item"
                      onClick={() =>
                        member.user_uid.startsWith("placeholder")
                          ? null
                          : handleMemberClick(member.user_uid)
                      }
                    >
                      <div className="leaderboard-list-item1">
                        <div className="leaderboard-rank-list1">{member.rank}</div>

                        <div className="leadership-name-image-container">
                          {member.showIcon ? (
                            <FaUserCircle style={{ fontSize: "40px", color: "gray" }} />
                          ) : (
                            <img
                              src={member.image}
                              alt={member.name}
                              className="leaderboard-list-image"
                            />
                          )}

                          <p className="leaderboard-list-name">
                            {member.user_uid.startsWith("placeholder")
                              ? "Not yet claimed"
                              : member.name}
                          </p>
                        </div>
                      </div>

                      <div className="leaderboard-list-points">
                        {member.user_uid.startsWith("placeholder")
                          ? "--"
                          : `${member.points} ${member.unit}`}
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}

            {/* Profile Popup */}
            {isProfilePopupOpen && userProfile && (
              <div
                className="member-profile-popup"
                onClick={() => setIsProfilePopupOpen(false)}
              >
                <div
                  className="member-profile-popup-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <span
                    className="member-profile-close"
                    onClick={() => setIsProfilePopupOpen(false)}
                  >
                    &times;
                  </span>

                    <div className="member-profile-header">
                      {userProfile.image ? (
                        <img
                          src={userProfile.image}
                          alt={`${userProfile.first_name} ${userProfile.last_name}`}
                          className="member-profile-image"
                          style={{
                            border: `3px solid ${getStatusInfo(userProfile.user_online_status)
                              .color
                              }`,
                            borderRadius: "50%",
                          }}
                        />
                      ) : (
                        <FaUserCircle
                          className="member-profile-placeholder"
                          style={{
                            color: getStatusInfo(userProfile.user_online_status)
                              .color,
                            border: `3px solid ${getStatusInfo(userProfile.user_online_status)
                              .color
                              }`,
                            borderRadius: "50%",
                            padding: "3px",
                          }}
                        />
                      )}
                      <div
                        style={{
                          textAlign: "center",
                          marginTop: "2px",
                          fontWeight: "500",
                          color: getStatusInfo(userProfile.user_online_status)
                            .color,
                        }}
                      >
                        {getStatusInfo(userProfile.user_online_status).label}
                      </div>
                      <div className="member-name-job">
                        <h2 className="member-name">{`${userProfile.first_name} ${userProfile.last_name}`}</h2>
                        <p className="member-job-title">
                          {userProfile.job_title || "—"}
                        </p>
                      </div>
                    </div>

                  <div className="leaderboard-member-details">
                    <div className="leaderboard-popup-row">
                      <FaEnvelope className="leaderboard-popup-icon" />
                      <div className="leaderboard-popup-text">
                        <div className="leaderboard-popup-label">Email:</div>
                        <div className="leaderboard-popup-value">
                          {userProfile.email || "—"}
                        </div>
                      </div>
                    </div>

                    <div className="leaderboard-popup-row">
                      <FaPhoneAlt className="leaderboard-popup-icon" />
                      <div className="leaderboard-popup-text">
                        <div className="leaderboard-popup-label">Mobile:</div>
                        <div className="leaderboard-popup-value">
                          {userProfile.mobile_phone || "—"}
                        </div>
                      </div>
                    </div>

                    <div className="leaderboard-popup-row">
                      <FaBuilding className="leaderboard-popup-icon" />
                      <div className="leaderboard-popup-text">
                        <div className="leaderboard-popup-label">Department:</div>
                        <div className="leaderboard-popup-value">
                          {userProfile.department || "—"}
                        </div>
                      </div>
                    </div>

                    <div className="leaderboard-popup-row">
                      <FaGlobe className="leaderboard-popup-icon" />
                      <div className="leaderboard-popup-text">
                        <div className="leaderboard-popup-label">Nationality:</div>
                        <div className="leaderboard-popup-value">
                          {userProfile.nationality || "—"}
                        </div>
                      </div>
                    </div>

                    <div className="leaderboard-popup-row">
                      <FaCity className="leaderboard-popup-icon" />
                      <div className="leaderboard-popup-text">
                        <div className="leaderboard-popup-label">City:</div>
                        <div className="leaderboard-popup-value">
                          {userProfile.city || "—"}
                        </div>
                      </div>
                    </div>

                      <div className="leaderboard-popup-row">
                        <MdOutlineDeviceUnknown className="leaderboard-popup-icon" />
                        <div className="leaderboard-popup-text">
                          <div className="leaderboard-popup-label">
                            Device type:
                          </div>
                          <div className="leaderboard-popup-value">
                            {userProfile.device_type || "-"}
                          </div>
                        </div>
                      </div>
                      <div className="leaderboard-popup-row">
                        <MdOutlineNotificationsActive className="leaderboard-popup-icon" />
                        <div className="leaderboard-popup-text">
                          <div className="leaderboard-popup-label">
                            Last Active:
                          </div>
                          <div className="leaderboard-popup-value">
                            {userProfile?.last_active
                              ? new Date(
                                userProfile.last_active
                              ).toLocaleString()
                              : "Never logged in"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </>
          ) : (
       
          <StreakLeaderboard />
        )}
        </div>
      )}
    </>    
  );
};

export default Leaderboard;
